import { render, staticRenderFns } from "./SetDragBox.vue?vue&type=template&id=7ce98d94&scoped=true"
import script from "./SetDragBox.vue?vue&type=script&lang=js"
export * from "./SetDragBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce98d94",
  null
  
)

export default component.exports